<template>
  <v-main>
    <v-app>
      <v-container grid-list-md>
        <v-layout row wrap v-if="dataReceived">
          <v-flex xs12>
            <v-card>
              <v-card-title>
                <v-btn @click="dataReceived = false" color="blue" dark>
                  <v-icon left dark>mdi-arrow-left</v-icon>
                  Editor
                </v-btn>

                <v-btn @click="csvExport" color="success" dark>
                  <v-icon left dark>mdi-cloud-download</v-icon>
                  Download CSV
                </v-btn>
                <v-spacer></v-spacer>
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                              hide-details></v-text-field>
              </v-card-title>

              <v-dialog v-model="dialog" max-width="800px">
                <v-card>
                  <v-card-title>
                    <span class="headline">Edit Row</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12>
                          <v-text-field v-model="editedItem.url" label="Url"></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-textarea v-model="editedItem.content" label="Content"></v-textarea>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
                    <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-data-table
                  :headers="[{
            text: 'URL',
            align: 'left',
            sortable: true,
            value: 'url'
          },{
            text: 'Content',
            align: 'left',
            sortable: false,
            value: 'content'
          },
          {
            text: 'Action',
            align: 'left',
            sortable: false,
          }]"
                  :items="responseFromAPI"
                  :loading="!dataReceived"
                  class="elevation-2 width-1-1"
                  :search="search"
                  item-key="url"
                  :footer-props="{'items-per-page-options': [30,60, { 'text': 'All', 'value': -1 }]}"
              >
                <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                <template slot="item" slot-scope="props">
                  <tr @click="props.expanded = !props.expanded">
                    <td>{{ props.item.url }}</td>
                    <td class="text-xs-right content-td">{{ decodeHTML(props.item.content) }}</td>
                    <td class="justify-center">
                      <v-icon small class="mr-2" @click="editItem(props.item)">mdi-pencil</v-icon>
                      <v-icon small @click="deleteItem(props.item)">mdi-delete</v-icon>
                    </td>
                  </tr>
                </template>
                <template v-slot:expanded-item="props">
                  <v-card-text v-html="decodeHTML(props.item.content)"></v-card-text>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-else>
          <v-flex xs6>
            <h2>Paste Content Here</h2>
            <editor
                api-key="9zpzmc4ml7p8dlum4zu4a1tg5jwrjg6aw5iux0lrot9ub58y"
                :init="{plugins: 'code, paste',menubar: 'tools',
            paste_use_dialog : false,
            paste_auto_cleanup_on_paste : true,
            paste_convert_headers_to_strong : false,
            paste_strip_class_attributes : 'all',
            paste_remove_spans : true,
            paste_remove_styles : true,
            paste_retain_style_properties : ''}"
                v-model="content"
                height="500"
                id="nr-editor"
                @onSelectionChange="updateContent"
            ></editor>
            <v-btn @click="createTxt" color="primary" class="mt-3">Generate Content</v-btn>
          </v-flex>
          <v-flex xs6>
            <v-card>
              <v-card-title primary-title>{{ newContent }}</v-card-title>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-app>

  </v-main>
</template>
<script>
import Editor from "@tinymce/tinymce-vue";
import axios from "axios";
import decode from "decode-html";
import {unparse} from "papaparse";

export default {
  components: {
    editor: Editor
  },
  data() {
    return {
      content: "",
      newContent: "",
      responseFromAPI: [],
      dataReceived: false,
      search: "",
      dialog: false,
      editedIndex: -1,
      editedItem: {
        url: "",
        content: ""
      },
      defaultItem: {
        url: "",
        content: ""
      }
    };
  },
  methods: {
    updateContent: function () {
      this.newContent = this.content.replace(
          /<(u|\/u|strong|\/strong)[^>]*>/g,
          ""
      );
      this.newContent = this.newContent.replace(
          /<p[^>]*>[\s|&nbsp;]*<\/p>/g,
          ""
      );


      this.newContent = this.newContent.replace(/(?:&nbsp;)+</g, "<")
      this.newContent = this.newContent.replace(/(?:&nbsp;)+</g, "")
      this.newContent = this.newContent.replace(/(<p>)[\s]*(www[a-z0-9\-\s./]*)[\s]*(<\/p>)/g, '$1<a href="$2" class="nr_page_link">$2</a>$3')
      this.newContent = this.newContent.replace(/(<p>)[\s]*<a(.*<\/a>)[\s]*(<\/p>)/g, '$1<a class="nr_page_link" $2$3')
      this.newContent = this.newContent.replace(/(<p>)[\s]*(Get|Contact|Call|[a-zA-Z.!\-,"'’_ &;:+?()]{1,100})[\s]*(<\/p>)/g, "<h2>$2</h2>")
      this.newContent = this.newContent.replace(/(<p>)[\s]*(Get|Contact|Call|[a-z\wA-Z.!\-,"'’_ &;:+?()\n]{1,100})[\s]*(<br[\s]*\/?>)[\s]*([a-zA-Z\w.!\-,"'’_ &;+]*)(<\/p>)/g, "<h2>$2</h2><p>$4</p>")
      this.newContent = this.newContent.replace(/(<h2>)[\s]*([a-zA-Z.!\-,"'’_ &;+]{350,})[\s]*(<\/h2>)/g, "<p>$2</p>")
      this.newContent = this.newContent.replace(/(<h1>)[\s]*([a-zA-Z.!\-,"'’_ &;:+?()]*)[\s]*(<\/h1>)/g, "<h2>$2</h2>")
    },
    createTxt: function () {
      this.updateContent();
      var textToWrite    = this.newContent;
      var textFileAsBlob = new Blob([textToWrite], {
        type: "text/html; charset=UTF-8"
      });

      const data = new FormData();
      data.append("file", textFileAsBlob);
      axios
          .post("https://nativerank.dev/aws/", data, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then(e => {
            console.log({e})
            this.responseFromAPI = e.data;
            this.dataReceived    = true;
          })
          .catch(e => {
            console.error(e);
          });
    },
    decodeHTML: function (text) {
      text = decode(text);
      return text;
    },
    downloadContent: function () {
      var textToWrite        = this.newContent;
      var textFileAsBlob     = new Blob([textToWrite], {
        type: "text/html; charset=UTF-8"
      });
      var fileNameToSaveAs   = "content.html";
      var downloadLink       = document.createElement("a");
      downloadLink.download  = fileNameToSaveAs;
      downloadLink.innerHTML = "Download File";
      if (window.webkitURL != null) {
        // Chrome allows the link to be clicked
        // without actually adding it to the DOM.
        downloadLink.href = window.webkitURL.createObjectURL(textFileAsBlob);

        const data = new FormData();
        data.append("data", textFileAsBlob);
      } else {
        // Firefox requires the link to be added to the DOM
        // before it can be clicked.
        downloadLink.href          = window.URL.createObjectURL(textFileAsBlob);
        // downloadLink.onclick = destroyClickedElement;
        downloadLink.style.display = "none";
        document.body.appendChild(downloadLink);
      }

      downloadLink.click();
    },
    editItem(item) {
      this.editedIndex = this.responseFromAPI.indexOf(item);
      this.editedItem  = Object.assign({}, item);
      this.dialog      = true;
    },

    deleteItem(item) {
      const index = this.responseFromAPI.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
      this.responseFromAPI.splice(index, 1);
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem  = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.responseFromAPI[this.editedIndex], this.editedItem);
      }
      this.close();
    },
    csvExport: function () {
      const csv  = unparse(this.responseFromAPI, {
        skipEmptyLines: true
      })
      const file = new Blob([csv])

      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveBlob(file, "filename.csv")
      } else {
        const link    = window.document.createElement('a')
        link.href     = window.URL.createObjectURL(file, {
          type: "text/plain"
        })
        link.download = "content.csv"
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }

    }
  },
  computed: {},

  watch: {
    dialog(val) {
      val || this.close();
    }
  }
};
</script>

<style lang="scss">
#nr-editor_ifr {
  min-height: 500px;
}

.width-1-1 {
  width: 100%;
}

.content-td {
  white-space: nowrap;
  max-width: 200px;
  overflow: auto;
}
</style>
